<template>
  <div class="page">

    <!-- Added button toast -->
   <!-- <v-snackbar
      v-model="addedButtonToast"
      top
      right
      :timeout="3000"
    >
      Button added
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="addedButtonToast = false"
        >
          {{ $t('Close') }}
        </v-btn>
      </template>
    </v-snackbar>-->
    <PageHeader
      :to="{ name: 'member-show' }"
    >
      <div slot="middle">{{ $route.params.taskId ? $t('Edit task') : $t('Create new task') }}</div>
      <div v-if="$route.params.taskId" slot="right">
        <v-btn
          color="red"
          outlined
          @click="showTaskDeleteModal = true"
        >{{ $t('Delete task') }}</v-btn>
      </div>
    </PageHeader>

    <!-- Task deletion confirm -->
    <ConfirmationModal
      v-if="showTaskDeleteModal"
      @confirm="deleteTask"
      @cancel="showTaskDeleteModal = false"
      :is-negative="true"
      :confirm-text="$t('Delete')"
      :title="`${$t('Delete task')}?`"
    ><TrashcanInfiniteRed/></ConfirmationModal>

    <!-- Time Tolerance confirmation -->
    <ConfirmationModal
      :title="$t('Confirm time tolerance')"
      v-if="showTimeToleranceConfirmation"
      @cancel="showTimeToleranceConfirmation = false"
      @confirm="confirmTimeTolerance"
    >
      <div class="mb-4">
        {{$t('Is the current time tolerance of X minutes correct?', {
        time: timeToleranceMinutes
        })}}
      </div>
    </ConfirmationModal>

    <div class="mid-section">
      <v-stepper v-model="currentStep" class="stepper" @change="stepChanged">

        <!-- STEPPER HEADER -->
        <v-stepper-header class="stepper-header pa-3" style="height: auto">
          <v-stepper-step
            step="1"
            :complete="currentStep > 1"
            editable
            class="v-stepper-hide-icon"
          >
            <div>
              <span
                :class="`number-bubble ${currentStep === '1' ?
                'number-bubble-selected' :
                'number-bubble-editable'}`"
              >1</span> {{ $t('Name') }}
            </div>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            step="2"
            :complete="!!form.name.length"
            :editable="!!form.name.length"
            class="v-stepper-hide-icon"
          >
            <div>
              <span
                :class="`number-bubble ${currentStep === '2' ?
                'number-bubble-selected' :
                !!form.name.length ?
                'number-bubble-editable' : ''}`"
              >2</span> {{ $t('Buttons') }}</div>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            step="3"
            :complete="!!form.name.length"
            :editable="!!form.name.length"
            class="v-stepper-hide-icon"
          >
            <div>
              <span
                :class="`number-bubble ${currentStep === '3' ?
                'number-bubble-selected' :
                !!form.name.length ?
                'number-bubble-editable' : ''}`"
              >3</span> {{ $t('Type') }}</div>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            step="4"
            :complete="!!form.name.length && !!form.type"
            :editable="!!form.name.length && !!form.type"
            class="v-stepper-hide-icon"
          >
            <div>
              <span
                :class="`number-bubble ${currentStep === '4' ?
                'number-bubble-selected' :
                !!form.name.length && !!form.type ?
                'number-bubble-editable' : ''}`"
              >4</span> {{ $t('Time') }}</div>
          </v-stepper-step>
        </v-stepper-header>

        <!-- STEPPER CONTENT -->
        <v-stepper-items class="col d-flex">
          <!-- Category -->
          <v-stepper-content
            step="1"
            class="pa-0"
            :class="currentStep === '1' ? 'd-flex flex-column justify-start' : 'd-none'"
          >
            <div class="step justify-start">
              <div class="page-sub-title">{{ $t('Give the task a name') }}</div>
              <v-text-field
                autofocus
                @keyup.enter="form.name.length ? currentStep = '2' : null"
                v-model="form.name"
              />
              <transition name="slide">
                <div
                  v-if="form.name"
                  class="align-self-stretch d-flex flex-column align-center mt-6"
                >
                  <v-btn color="primary" @click="currentStep = '2'">{{ $t('Continue') }}</v-btn>
                </div>
              </transition>
            </div>
          </v-stepper-content>

          <!-- Buttons -->
          <v-stepper-content
            step="2"
            class="pa-0"
            :class="currentStep === '2' ? 'd-flex flex-column justify-center' : 'd-none'"
          >
            <div class="step">
            <!-- Add button modal -->
            <v-dialog
              v-model="addButtonModal"
              max-width="500"
              @input="buttonModalEditMode = false"
            >
              <v-card class="pa-8">
                <!--<div class="d-flex justify-space-between align-start">
                  &lt;!&ndash; Button color choices &ndash;&gt;
                  <div class="choice-color buttonLightblue buttonLightblue&#45;&#45;text"></div>
                  <div class="choice-color buttonGreen buttonGreen&#45;&#45;text"></div>
                  <div class="choice-color buttonOrange buttonOrange&#45;&#45;text"></div>
                  <div class="choice-color buttonRed buttonRed&#45;&#45;text"></div>
                  <div class="choice-color buttonGrey buttonGrey&#45;&#45;text"></div>
                  <div class="choice-color buttonWhite buttonWhite&#45;&#45;text"></div>
                  <div class="choice-color buttonYellow buttonYellow&#45;&#45;text"></div>
                  <div class="choice-color buttonCyan buttonCyan&#45;&#45;text"></div>
                  <div class="choice-color buttonTeal buttonTeal&#45;&#45;text"></div>
                  <div class="choice-color buttonBlue buttonBlue&#45;&#45;text"></div>
                </div>-->
                <div class="page-sub-title">
                  {{ useShorthand ? $t('Enter button ID') : $t('Enter MAC address') }}
                </div>

                <div class="d-flex align-center">
                  <!-- must be kept in div to prevent v-mask from bleeding into other input -->
                  <div v-if="!useShorthand" style="width: 100%">
                    <v-text-field
                      class="shorthand-input pr-2"
                      autofocus
                      :value="buttonMACInput"
                      @keyup.enter="buttonMACInput.length === 17 ? addButton() : null"
                      @input="buttonMACInput = $event.toUpperCase(); shorthandError = false;"
                      v-mask="'XX:XX:XX:XX:XX:XX'"
                    >
                    </v-text-field>
                  </div>

                  <v-text-field
                    v-if="useShorthand"
                    class="shorthand-input pr-2"
                    v-model="buttonShorthandInput"
                    @keyup.enter="buttonShorthandInput.length ? addButton() : null"
                    @input="shorthandError = false"
                  />

                  <v-btn
                    :disabled="(!useShorthand && buttonMACInput.length !== 17)
                    || (useShorthand && !buttonShorthandInput.length)"
                    @click="addButton"
                    outlined
                    color="primary"
                    icon
                  ><v-icon>mdi-magnify</v-icon></v-btn>
                </div>
                <div class="shorthand-error" v-if="shorthandError">
                  {{ shorthandError }}
                </div>
                <div class="shorthand-switch" @click="useShorthand = !useShorthand">
                  {{ useShorthand ? $t('Use MAC address') : $t('Use button ID') }}
                </div>
              </v-card>
            </v-dialog>
            <!-- Add button modal end -->

              <div class="page-sub-title mb-8">{{ $t('Buttons') }}</div>
              <div class="d-flex mb-10">
                <div
                  v-for="(button, index) in form.buttons"
                  :key="button.mac"
                  class="button-box"
                >
                  <!--<div
                    class="button-color"
                    :style="`background-color: ${buttonColors[index]}`"
                  ></div>-->
                  <div class="button-mac">{{ button.macAddress }}</div>
                  <div style="height: 150px; width: 150px;margin: auto;">
                    <ButtonTilt />
                  </div>
                  <div class="d-flex">
                    <div
                      @click="removeButton(index)"
                      class="button-delete"
                    >{{ $t('Remove') }}</div>
                    <div
                      class="button-edit"
                      @click="editButton(index)"
                    >{{ $t('Edit') }}</div>
                  </div>

                </div>
                <div
                  class="add-button-box"
                  @click.stop="addButtonModal = true"
                >
                  <v-icon
                    color="primary"
                    size="70px"
                  >mdi-plus-box-outline</v-icon>
                  <div class="add-button-text">{{ $t('Add button') }}</div>
                </div>
              </div>

              <div>
                  <v-btn class="mr-4" @click="backToStep('1')">{{ $t('Back') }}</v-btn>
                  <v-btn color="primary" @click="currentStep = '3'">{{ $t('Continue') }}</v-btn>
                </div>
            </div>

          </v-stepper-content>

          <!-- Type -->
          <v-stepper-content
            step="3"
            class="pa-0"
            :class="currentStep === '3' ? 'd-flex flex-column justify-center' : 'd-none'"
          >
            <div class="step">
              <div class="page-sub-title">{{ $t('Select a type') }}</div>
              <div class="d-flex justify-center align-center my-8">
                <div
                  v-for="type in types"
                  :key="type.name"
                  @click="setType(type)"
                  :class="form.type && form.type.value === type.value ?
                  'choice-type-selected': 'choice-type'"
                >
                  <div style="height: 120px; width: 120px;">
                    <BradenTask v-if="type.name === 'Braden'"/>
                    <TimerTask v-if="type.name === 'Timer'" />
                    <ScheduleTask v-if="type.name === 'Schedule'" />
                    <OnDemandTask v-if="type.name === 'On demand'" />
                  </div>
<!--                  <v-icon>{{ type.icon }}</v-icon>-->
                  <div>{{ $t(type.name) }}</div>
                </div>
              </div>
              <v-btn @click="backToStep('2')">{{ $t('Back') }}</v-btn>
            </div>
          </v-stepper-content>

          <!-- Time -->
          <v-stepper-content
            step="4"
            class="pa-0"
            :class="currentStep === '4' ? 'd-flex flex-column justify-start' : 'd-none'"
          >
            <div class="step">
              <div class="page-sub-title">
                {{ form.type && form.type.name === 'Braden' ?
                `${$t('Enter Braden Score')}` :
                  form.type && form.type.value === 'timerTask' ?
                `${ $t('How much time should pass between each click') }?` :
                form.type && form.type.value === 'scheduledTask' ?
                $t('Select time') :
                form.type && form.type.value === 'onDemandTask' ?
                $t('On demand requires no planning') : ''
                }}
              </div>
              <!-- Timer & Braden -->
              <div
                v-if="form.type &&
                (form.type.value === 'timerTask' || form.type.value === 'bradenTask')"
                class="my-8 text-center d-flex flex-column align-center"
                :class="form.type.name === 'Braden' ? 'mt-2 mb-8' : 'my-8'"
                style="width: 600px; max-width: 100%;"
              >
                <!-- Timer start modal -->
                <TimeSelectionModal
                  v-if="timerStartModal"
                  @close="closeTimerStartModal"
                  @submit="setTimerStart"
                  :value="timerStartInput"
                />
                <!--<v-dialog
                  v-if="timerStartModal"
                  v-model="timerStartModal"
                  width="180px"
                  @input="closeTimerStartModal"
                  content-class="dialog-center-margin"
                >
                  <div class="white d-flex align-center justify-space-between pa-2">
                    <v-text-field
                      v-model="timerStartInput"
                      v-mask="'##:##'"
                      pattern="[0-9]*"
                      inputmode="tel"
                      placeholder="08:00"
                      class="mr-4"
                      autofocus
                      @keyup.enter="setTimerStart"
                    ></v-text-field>
                    &lt;!&ndash;<input
                      type="time"
                      v-model="newTime"
                      class="ml-2"
                    >&ndash;&gt;
                    <v-btn
                      color="primary"
                      @click="setTimerStart"
                    >{{ $t('Ok') }}</v-btn>
                  </div>
                </v-dialog>-->
                <div
                  v-if="form.type.name !== 'Braden'"
                  class="my-8 time-between"
                > {{ timerLabels[timerTimeBetween].label }} </div>
                <v-slider
                  v-if="form.type.name !== 'Braden'"
                  v-model="timerTimeBetween"
                  :max="14"
                  ticks
                  tick-size="3"
                  step="1"
                  class="slider"
                ></v-slider>

                <div
                  v-if="form.type.name === 'Braden'"
                  style="width: 100px;"
                >
                  <v-text-field
                    v-model="bradenScore"
                    placeholder="0-23"
                    max="23"
                    min="0"
                    v-mask="'##'"
                    pattern="[0-9]*"
                    @input="validateBradenScore"
                  ></v-text-field>
                </div>

                <div class="text-center">{{ $t('When should the timer start') }}?</div>
                <div class="d-flex justify-center">
                  <div
                    @click="clearTimerStart"
                    class="frequency-item"
                    :class="{ 'frequency-item-selected' : timerStart === null }"
                  >{{ $t('Now') }}</div>
                  <div
                    @click="timerStartModal = true"
                    class="frequency-item"
                    :class="{ 'frequency-item-selected' : timerStart !== null }"
                  >
                    {{ timerStart ? timerStart : $t('Set a time') }}
                  </div>
                </div>

              </div>

              <!-- Schedule -->
              <div
                v-if="form.type &&
                (form.type.value === 'scheduledTask'
                || form.type.value === 'scheduledOnDemandTask')"
                class="d-flex flex-column align-center align-self-stretch"
              >
                <div class="d-flex flex-column">
                  <div class="mt-6">{{ $t('Occurrence') }}</div>
                  <div class="d-flex">
                    <div
                      @click="setPlanDayFrequency('daily')"
                      class="frequency-item"
                      :class="{ 'frequency-item-selected' : form.planDayFrequency === 'daily' }"
                    >{{ $t('Every day') }}</div>
                    <div
                      @click="setPlanDayFrequency('specific')"
                      class="frequency-item"
                      :class="{ 'frequency-item-selected' : form.planDayFrequency === 'specific' }"
                    >
                      {{ $t('Specific weekdays') }}
                    </div>
                  </div>
                </div>

                <transition name="slide">
                  <div
                    v-if="form.planDayFrequency"
                    class="d-flex flex-column"
                  >
                    <!-- New time modal -->
                    <TimeSelectionModal
                      v-if="addTimeModal"
                      :value="newTime"
                      @submit="addNewTime"
                      @close="closeNewTimeModal"
                    />

                    <!-- Specific weekdays -->
                    <transition name="slide">
                      <div
                        v-if="form.planDayFrequency === 'specific'"
                        class="mt-6 d-flex flex-column"
                      >
                        <div>{{ $t('Select days') }}</div>

                        <div class="d-flex">
                          <div
                            v-for="key in Object.keys(form.planSpecificDays)"
                            :key="key"
                            class="frequency-item"
                            :class="{ 'frequency-item-selected' : form.planSpecificDays[key] }"
                            @click="form.planSpecificDays[key] = !form.planSpecificDays[key]"
                          >{{ $t(key) }}</div>
                        </div>
                      </div>
                    </transition>

                    <!-- <div>
                      <div>{{ $t('Allow clicks outside of schedule?') }}</div>
                      <input
                        class="input-checkbox"
                        type="checkbox"
                        v-model="form.scheduledOnDemand"
                      >
                    </div> -->

                    <div>
                      <div>{{ $t('Put on pause') }}</div>
                      <input
                        class="input-checkbox"
                        type="checkbox"
                        v-model="form.isPaused"
                      >
                    </div>

                    <div
                      class="d-flex justify-space-between"
                      :class="{ 'paused-effect' : form.isPaused === true }"
                    >
                      <div class="d-flex flex-column">
                        <div class="mt-6">{{ $t('Select time') }}</div>
                        <div
                          class="d-flex"
                        >
                          <v-btn
                            v-for="(time, index) in form.times"
                            :key="index"
                            color="primary"
                            outlined
                            class="mr-2"
                            @click="editTime(index)"
                          >
                            <span style="pointer-events: none">{{ time }}</span>
                            <v-icon
                              @click.stop="removeTime(index)"
                              class="ml-2"
                            >mdi-close</v-icon>
                          </v-btn>
                          <v-btn
                            color="primary"
                            outlined
                            @click="openNewTimeModal"
                          >{{ $t('Add time') }}</v-btn>
                        </div>
                      </div>

                      <div class="d-flex flex-column align-end">
                        <div class="mt-6">{{ $t('Time tolerance in minutes') }}</div>
                        <v-text-field
                          v-model="timeToleranceMinutes"
                          type="number"
                          style="width:60px"
                          @change="validateTimeToleranceMinutes"
                        ></v-text-field>
                      </div>
                    </div>
                    <DayCalendar
                      :key="currentStep"
                      class="day-calendar"
                      :tasks="taskPreview"
                      display-only
                      scale-up
                      scale-down
                      :class="{ 'paused-effect' : form.isPaused === true }"
                    />
                  </div>
                </transition>

              </div>

              <div v-if="overlappingTimes">{{ $t('Times can not overlap') }}</div>
              <div class="d-flex align-center mt-6">
                <v-btn class="mr-4" @click="backToStep('3')">{{ $t('Back') }}</v-btn>
                <v-btn
                  :disabled="!canSubmit"
                  color="primary"
                  @click="addTask"
                  :loading="loading"
                >{{ editTask ? $t('Save changes') : $t('Add task') }}</v-btn>
              </div>

            </div>
          </v-stepper-content>
        </v-stepper-items>

      </v-stepper>
    </div>
  </div>
</template>

<script>

import { mask } from 'vue-the-mask';
import PageHeader from '@/globals/components/PageHeader.vue';
import DayCalendar from '@/modules/calendar/DayCalendar.vue';
import {
  setMinutes, setHours, subMinutes, addMinutes, isWithinInterval, subSeconds, addSeconds, isBefore,
  addDays, setSeconds, getUnixTime, getDay, format, fromUnixTime,
} from 'date-fns';
import { api } from '@/store';
import TimerTask from '@/modules/svg/TimerTask.vue';
import BradenTask from '@/modules/svg/BradenTask.vue';
import ScheduleTask from '@/modules/svg/ScheduleTask.vue';
import OnDemandTask from '@/modules/svg/OnDemandTask.vue';
import ConfirmationModal from '../../globals/components/ConfirmationModal.vue';
import ButtonTilt from '../../modules/svg/ButtonTilt.vue';
import TrashcanInfiniteRed from '../../modules/svg/TrashcanInfiniteRed.vue';
import TimeSelectionModal from '../../globals/components/TimeSelectionModal.vue';

export default {
  directives: {
    mask,
  },
  components: {
    PageHeader,
    DayCalendar,
    ConfirmationModal,
    ButtonTilt,
    TrashcanInfiniteRed,
    TimerTask,
    BradenTask,
    ScheduleTask,
    OnDemandTask,
    TimeSelectionModal,
  },
  data() {
    return {
      buttonColors: ['#6484ff', '#eb4034', '#7cd658'],
      addedButtonToast: false,
      useShorthand: true,
      currentStep: '1',
      editTask: null,
      shorthandError: false,
      loading: false,
      form: {
        name: '',
        scheduledOnDemand: false,
        category: null,
        buttons: [],
        type: null,
        times: [],
        planDayFrequency: null,
        isPaused: false,
        planSpecificDays: {
          Monday: false,
          Tuesday: false,
          Wednesday: false,
          Thursday: false,
          Friday: false,
          Saturday: false,
          Sunday: false,
        },
      },
      bradenScore: 0,
      addButtonModal: false,
      addTimeModal: false,
      timerStartModal: false,
      timeToleranceMinutes: 60,
      timeToleranceHasBeenChanged: false,
      showTimeToleranceConfirmation: false,
      timerStart: null,
      timerStartInput: null,
      newTime: null,
      buttonMACInput: '',
      buttonShorthandInput: '',
      buttonModalEditMode: null,
      timeModalEditMode: null,
      showTaskDeleteModal: false,
      types: [
        // {
        //   name: 'Timer',
        //   value: 'timerTask',
        //   icon: 'mdi-av-timer',
        // },
        {
          name: 'Schedule',
          value: 'scheduledTask',
          icon: 'mdi-calendar-month-outline',
        },
        {
          name: 'On demand',
          value: 'onDemandTask',
          icon: 'mdi-access-point',
        },
        // {
        //   name: 'Braden',
        //   value: 'bradenTask',
        //   icon: 'mdi-av-timer',
        // },
      ],
      timerTimeBetween: 1,
      timerLabels: [
        { label: `30 ${this.$t('minutes')}`, value: 1800 },
        { label: `1 ${this.$t('hour')}`, value: 3600 },
        { label: `1½ ${this.$t('hour')}`, value: 5400 },
        { label: `2 ${this.$t('hours')}`, value: 7200 },
        { label: `3 ${this.$t('hours')}`, value: 10800 },
        { label: `4 ${this.$t('hours')}`, value: 14400 },
        { label: `5 ${this.$t('hours')}`, value: 18000 },
        { label: `6 ${this.$t('hours')}`, value: 21600 },
        { label: `8 ${this.$t('hours')}`, value: 28800 },
        { label: `10 ${this.$t('hours')}`, value: 36000 },
        { label: `12 ${this.$t('hours')}`, value: 43200 },
        { label: `16 ${this.$t('hours')}`, value: 57600 },
        { label: `20 ${this.$t('hours')}`, value: 72000 },
        { label: `24 ${this.$t('hours')}`, value: 86400 },
      ],
    };
  },
  computed: {
    canSubmit() {
      if (this.loading) {
        return false;
      }

      if (this.form.type) {
        if (this.form.type.value === 'scheduledTask' || this.form.type.value === 'scheduledOnDemandTask') {
          if (!this.form.times.length || this.overlappingTimes) {
            return false;
          }
        }
      }
      return true;
    },
    currentTime() {
      return Date.now();
    },
    /* categories() {
      return this.$Category.all();
    }, */
    taskPreview() {
      return [{
        zones: this.form.times.map((time) => {
          const [hours, minutes] = time.split(':');
          return {
            fill: '#0dac30',
            startTime: subSeconds(
              setSeconds(setMinutes(setHours(this.currentTime, hours), minutes), 0),
              this.timeToleranceMinutes * 60,
            ),
            endTime: addSeconds(
              setSeconds(setMinutes(setHours(this.currentTime, hours), minutes), 0),
              this.timeToleranceMinutes * 60,
            ),
          };
        }),
        schedule: {
          tolerance: this.timeToleranceMinutes * 60,
          intervals: [],
        },
      }];
      /* return [{
        schedule: {
          tolerance: this.timeToleranceMinutes * 60,
          intervals: this.form.times.map((time) => ({
            interval: 86400,
            timestamp: setSeconds(setMinutes(setHours(this.currentTime, hours), minutes), 0),
          })),
        },
        events: [],
      }]; */
    },
    overlappingTimes() {
      const tolerance = this.taskPreview[0].schedule.tolerance / 60;
      const allIntervals = this.taskPreview[0].schedule.intervals.map((time) => ({
        timestamp: time.timestamp,
        // add 1 second and remove 1 second from start and end, to avoid exact time overlaps
        // so a schedules can be set like 10-12 12-14, otherwise they would collide exactly at 12
        start: addSeconds(subMinutes(time.timestamp, tolerance), 1),
        end: subSeconds(addMinutes(time.timestamp, tolerance), 1),
      }));

      let hasOverlap = false;
      allIntervals.forEach((interval) => {
        const overlappingItem = allIntervals.find((time) => {
          if (time.timestamp === interval.timestamp) return false;

          // check if timestamp is within
          if (isWithinInterval(interval.timestamp, {
            start: time.start,
            end: time.end,
          })) {
            return true;
          }
          // check if start of interval overlaps
          if (isWithinInterval(interval.start, {
            start: time.start,
            end: time.end,
          })) {
            return true;
          }
          // check if end of interval overlaps
          if (isWithinInterval(interval.end, {
            start: time.start,
            end: time.end,
          })) {
            return true;
          }
          return false;
        });
        if (overlappingItem) {
          hasOverlap = true;
        }
      });
      return hasOverlap;
    },
  },
  watch: {
    newTime: {
      handler(newVal) {
        this.validateNewTime(newVal);
      },
    },
  },
  mounted() {
    // this.$Category.api().fetchByGroupName(this.$route.params.groupName);
    if (this.$route.params.taskId) {
      this.timeToleranceHasBeenChanged = true;
      const task = this.$Task.query()
        .where((item) => item.uuid === this.$route.params.taskId).get()[0];
      if (task) {
        this.editTask = task;
        this.form.name = task.name;
        this.form.isPaused = task.isPaused;
        this.form.buttons = task.buttons ? task.buttons : [];
        if (task.type === 'scheduledOnDemandTask') {
          this.form.type = this.types.find((item) => item.value === 'scheduledTask');
          this.form.scheduledOnDemand = true;
        } else {
          this.form.type = this.types.find((item) => item.value === task.type);
        }

        if (task.type === 'timerTask') {
          this.timerTimeBetween = this.timerLabels
            .findIndex((item) => item.value === task.schedule.intervals[0].interval);
          this.timerStart = format(fromUnixTime(task.schedule.intervals[0].timestamp), 'HH:mm');
        }

        if (task.type === 'bradenTask') {
          this.bradenScore = task.bradenScore;
          this.timerStart = format(fromUnixTime(task.schedule.intervals[0].timestamp), 'HH:mm');
        }

        if (task.type === 'scheduledTask' || task.type === 'scheduledOnDemandTask') {
          if (task.schedule.intervals[0].interval === 86400) {
            this.form.planDayFrequency = 'daily';
            this.form.times = task.schedule.intervals.map((item) => format(fromUnixTime(item.timestamp), 'HH:mm')).sort();
          } else {
            this.form.planDayFrequency = 'specific';
            const dayIndexes = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

            const specificDaysSummary = this.editTask.schedule.intervals.reduce((acc, cur) => {
              const date = fromUnixTime(cur.timestamp);
              return {
                days: [...new Set([...acc.days, ...[dayIndexes[getDay(date)]]])],
                times: [...new Set([...acc.times, ...[format(date, 'HH:mm')]])],
              };
            }, { days: [], times: [] });
            this.form.times = specificDaysSummary.times;
            specificDaysSummary.days.forEach((day) => {
              this.form.planSpecificDays[day] = true;
            });
          }
          this.timeToleranceMinutes = task.schedule.tolerance / 60;
        }

        this.currentStep = '4';
      } else {
        this.$router.push({ name: 'member-show' });
      }
    }
  },
  methods: {
    deleteTask() {
      if (this.showTaskDeleteModal) {
        this.showTaskDeleteModal = false;
      }
      this.$Task.api().removeTask(this.$route.params.taskId).then(() => {
        this.$toast(this.$t('Task deleted'), { type: 'error' });
        this.$router.push({ name: 'member-show' });
      });
    },
    /* setCategory(category) {
      this.form.category = category;
      if (!category.children.length) {
        this.currentStep = '2';
      }
    }, */
    confirmTimeTolerance() {
      this.showTimeToleranceConfirmation = false;
      this.timeToleranceHasBeenChanged = true;
      this.addTask();
    },
    setType(value) {
      this.form.type = value;
      this.currentStep = '4';
    },
    backToStep(value) {
      this.currentStep = value;
      this.stepChanged();
    },
    stepChanged() {
      if (!this.editTask) {
        this.form.type = null;
      }
    },
    addButton() {
      if (this.useShorthand) {
        api.get(`${process.env.VUE_APP_API_URL}buttons/shorthand/${this.buttonShorthandInput}`).then((response) => {
          if (this.form.buttons.find((button) => button.macAddress === response.data.macAddress)) {
            this.shorthandError = this.$t('Button ID not found');
            return;
          }
          if (this.buttonModalEditMode !== null) {
            this.form.buttons[this.buttonModalEditMode] = { macAddress: response.data.macAddress };
          } else {
            this.form.buttons.push({ macAddress: response.data.macAddress });
          }
          this.addedButtonToast = true;
          this.buttonMACInput = '';
          this.buttonShorthandInput = '';
          this.buttonModalEditMode = null;
          this.addButtonModal = false;
        }).catch(() => {
          this.shorthandError = this.$t('Button ID not found');
        });
      } else {
        if (this.buttonModalEditMode !== null) {
          this.form.buttons[this.buttonModalEditMode] = { macAddress: this.buttonMACInput };
        } else {
          this.form.buttons.push({ macAddress: this.buttonMACInput });
        }
        this.addedButtonToast = true;
        this.buttonMACInput = '';
        this.buttonShorthandInput = '';
        this.buttonModalEditMode = null;
        this.addButtonModal = false;
      }
    },
    removeButton(index) {
      this.form.buttons.splice(index, 1);
    },
    setPlanDayFrequency(value) {
      this.form.planDayFrequency = value;
    },
    addNewTime(time) {
      console.log('x', time);
      const validated = this.validateNewTime(time);
      if (validated) {
        if (this.timeModalEditMode) {
          this.form.times[this.timeModalEditMode.index] = time;
        } else {
          this.form.times.push(time);
        }
        this.form.times.sort();
        this.closeNewTimeModal();
      }
    },
    removeTime(index) {
      this.form.times.splice(index, 1);
    },
    resetNewTime() {
      this.newTime = null;
    },
    closeNewTimeModal() {
      this.addTimeModal = false;
      this.newTime = null;
      this.timeModalEditMode = null;
    },
    openNewTimeModal() {
      this.addTimeModal = true;
      this.resetNewTime();
      if (this.timeModalEditMode) {
        this.newTime = this.timeModalEditMode.time;
      }
    },
    validateTimeToleranceMinutes() {
      this.timeToleranceHasBeenChanged = true;
      if (this.timeToleranceMinutes < 10 || this.timeToleranceMinutes === '') {
        this.timeToleranceMinutes = 10;
      } else if (this.timeToleranceMinutes > 600) {
        this.timeToleranceMinutes = 600;
      }
    },
    validateNewTime(value) {
      if (value) {
        console.log('validation: ', value);
        if (value.length === 5) {
          let [hours, minutes] = value.split(':');
          if (hours > 23) {
            hours = 23;
          }
          if (minutes > 59) {
            minutes = 59;
          }
          // Use nextTick to avoid desync of v-model and input
          this.$nextTick(() => {
            this.newTime = [hours, minutes].join(':');
          });
          return true;
        }
        return false;
      }
      return false;
    },
    editTime(index) {
      this.timeModalEditMode = {
        time: this.form.times[index],
        index,
      };
      this.openNewTimeModal();
    },
    validateBradenScore() {
      if (this.bradenScore > 23) {
        this.$nextTick(() => {
          this.bradenScore = 23;
        });
      } else if (this.bradenScore < 0) {
        this.$nextTick(() => {
          this.bradenScore = 0;
        });
      }
    },
    addTask() {
      this.loading = true;
      const data = {
        type: this.form.type.value === 'scheduledTask' && this.form.scheduledOnDemand
          ? 'scheduledOnDemandTask'
          : this.form.type.value,
        name: this.form.name,
        user: this.$route.params.userId,
        isPaused: this.form.isPaused,
        description: '',
        group: this.$route.params.groupName,
        buttons: this.form.buttons,
      };

      switch (this.form.type.value) {
        default:
          // default case will run for onDemandTask
          // onDemandTask has no schedule, unlike other task types
          break;

        case 'scheduledTask':
          data.schedule = {
            resetTimer: false,
            tolerance: this.timeToleranceMinutes * 60,
          };

          if (!this.timeToleranceHasBeenChanged) {
            this.showTimeToleranceConfirmation = true;
            this.loading = false;
            return;
          }

          if (this.form.planDayFrequency === 'daily') {
            // Calculation of timestamps for daily frequency
            data.schedule.intervals = this.form.times.map((time) => {
              const [hours, minutes] = time.split(':');
              let setTimestamp = setSeconds(
                setMinutes(setHours(this.currentTime, hours), minutes),
                0,
              );
              while (isBefore(setTimestamp, this.currentTime)) {
                setTimestamp = addDays(setTimestamp, 1);
              }
              return {
                interval: 86400, // 86400 is a day in seconds
                timestamp: getUnixTime(setTimestamp),
              };
            });
          }

          if (this.form.planDayFrequency === 'specific') {
            // Calculation of timestamps for specific days of week
            // Filter not-selected days
            const daysToSchedule = Object.keys(this.form.planSpecificDays)
              .filter((day) => this.form.planSpecificDays[day]);

            // mappedDays for reference with date-fns getDay
            const mappedDays = {
              Sunday: 0,
              Monday: 1,
              Tuesday: 2,
              Wednesday: 3,
              Thursday: 4,
              Friday: 5,
              Saturday: 6,
            };

            data.schedule.intervals = this.form.times.reduce((acc, cur) => {
              // iterate through each "time" of day (09:00) etc.
              const [hours, minutes] = cur.split(':');
              const timestampsToAdd = [];
              daysToSchedule.forEach((day) => {
                // iterate through all selected days
                let setTimestamp = setSeconds(
                  setMinutes(setHours(this.currentTime, hours), minutes),
                  0,
                );
                // if day of week doesn't match or time is before currentTime, add another day
                while (getDay(setTimestamp) !== mappedDays[day]
                || isBefore(setTimestamp, this.currentTime)) {
                  setTimestamp = addDays(setTimestamp, 1);
                }
                timestampsToAdd.push({
                  interval: 604800, // 604800 is a week in seconds
                  timestamp: getUnixTime(setTimestamp),
                });
              });

              return [...acc, ...timestampsToAdd];
            }, []);
          }
          break;

        case 'timerTask':
          data.schedule = {
            resetTimer: true,
            tolerance: 0,
            intervals: [
              {
                interval: this.timerLabels[this.timerTimeBetween].value,
                timestamp: (() => {
                  if (this.timerStart) {
                    const [hours, minutes] = this.timerStart.split(':');
                    let timeToStart = setMinutes(setHours(Date.now(), hours), minutes);
                    if (isBefore(timeToStart, Date.now())) {
                      timeToStart = addDays(timeToStart, 1);
                    }
                    return getUnixTime(timeToStart);
                  }
                  return getUnixTime(
                    addSeconds(Date.now(), this.timerLabels[this.timerTimeBetween].value),
                  );
                })(),
              },
            ],
          };
          break;

        case 'bradenTask':
          data.schedule = {
            resetTimer: true,
            tolerance: 0,
            intervals: [{
              interval: 0,
              timestamp: (() => {
                if (this.timerStart) {
                  const [hours, minutes] = this.timerStart.split(':');
                  let timeToStart = setMinutes(setHours(Date.now(), hours), minutes);
                  if (isBefore(timeToStart, Date.now())) {
                    timeToStart = addDays(timeToStart, 1);
                  }
                  return getUnixTime(timeToStart);
                }
                return getUnixTime(
                  addSeconds(Date.now(), (() => {
                    if (this.bradenScore <= 9) return 120 * 60;
                    if (this.bradenScore >= 15) return 360 * 60;
                    return 240 * 60;
                  }
                  )()),
                );
              })(),
            }],
          };
          if (this.bradenScore <= 9) {
            data.schedule.intervals[0].interval = 120 * 60;
            data.bradenScore = Number(this.bradenScore);
          } else if (this.bradenScore >= 15) {
            data.schedule.intervals[0].interval = 360 * 60;
            data.bradenScore = Number(this.bradenScore);
          } else {
            data.schedule.intervals[0].interval = 240 * 60;
            data.bradenScore = Number(this.bradenScore);
          }

          break;
      }

      if (this.$route.params.taskId) {
        this.$Task.api().updateTask(this.editTask.uuid, data).then(() => {
          this.$toast(this.$t('Task updated'), { type: 'success' });
          this.$router.push({ name: 'member-show', params: { userId: this.$route.params.userId } });
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.$Task.api().createTask(data).then(() => {
          this.$toast(this.$t('Task added'), { type: 'success' });
          this.$router.push({ name: 'member-show', params: { userId: this.$route.params.userId } });
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    editButton(index) {
      this.addButtonModal = true;
      this.buttonModalEditMode = index;
      this.buttonMACInput = this.form.buttons[index].macAddress;
    },
    closeTimerStartModal() {
      this.timerStartModal = false;
      this.timerStartInput = this.timerStart;
    },
    clearTimerStart() {
      this.timerStart = null;
      this.timerStartInput = null;
    },
    setTimerStart(time) {
      this.timerStart = time;
      this.closeTimerStartModal();
    },
  },
};
</script>

<style scoped lang="scss">
  .paused-effect {
    opacity: 0.3;
  }

  .page {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .mid-section {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .stepper {
    box-shadow: none !important;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .stepper-header {
    box-shadow: none !important;
  }

  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 200px;
  }

  .choice-category {
    width: 20%;
    max-width: 200px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid $primary;
    border-radius: 8px;
    padding: 8px;
    margin: 0px 8px 0px 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(100, 132, 255, 0.3);
    }

    img {
      color: $primary !important;
      font-size: 50px;
      max-width: 50px;
      max-height: 50px;
    }

    div {
      margin-top: 10px;
      font-size: 1em;
      color: #707070;
    }
  }

  .choice-subcategory {
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid $primary;
    border-radius: 8px;
    padding: 8px;
    margin: 0px 8px 0px 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(100, 132, 255, 0.3);
    }

    img {
      color: $primary !important;
      font-size: 50px;
      max-width: 50px;
      max-height: 50px;
    }

    div {
      margin-top: 10px;
      font-size: 1em;
      color: #707070;
    }
  }

  .choice-type, .choice-type-selected {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid $primary;
    color: $primary;
    border-radius: 8px;
    padding: 8px;
    margin: 0px 8px 0px 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(100, 132, 255, 0.3);
    }

    i {
      color: $primary !important;
      font-size: 50px;
    }

    div {
      margin-top: 10px;
      font-size: 20px;
      color: #707070;
    }
  }

  .choice-type-selected {
    color: #fff;
    background-color: $primary;

    i {
      color: white !important;
    }

    div {
      color: #fff;
    }
  }

  .time-between {
    color: $primary;
    font-size: 30px;
    font-weight: 200;
  }

  .frequency-item {
    border: 1px solid $primary;
    border-radius: 4px;
    padding: 8px 24px;
    margin: 0px 4px;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      background-color: rgba(100, 132, 244, 0.3);
    }

    &-selected {
      color: #fff;
      background-color: $primary;

      &:hover {
        background-color: $primary;
      }
    }
  }

  .shorthand-error {
    color: red;
    font-size: 12px;
  }

  .switch-to-mac {
    color: $primary;
    font-size: 13px;
    cursor: pointer;
    display: inline-block;
    padding: 2px 8px;
    border-radius: 2px;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(100, 132, 244, 0.3);
    }
  }

  .button-box {
    width: 200px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 0px 10px;
    border-radius: 8px;
    background-color: $primaryDark;
    -webkit-box-shadow: 2px 2px 9px 1px rgba(0,0,0,0.23);
    -moz-box-shadow: 2px 2px 9px 1px rgba(0,0,0,0.23);
    box-shadow: 2px 2px 9px 1px rgba(0,0,0,0.23);
    position: relative;
  }

  .shorthand-switch {
    font-size: 12px;
    color: $primary;
    cursor: pointer;
    transition: background-color 0.2s;
    display: inline-block;
    padding: 6px;
    border-radius: 4px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .button-mac {
    font-size: 13px;
    font-weight: bold;
    padding: 12px 16px 0px 16px;
    color: #f4f4f4;
  }

  .button-delete {
    background-color: #ee5f5f;
    color: #fff;
    flex: 1;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 0px;
    transition: all 0.2s;
    border-radius: 0 0 0 4px;

    &:hover {
      background-color: #e34646;
    }
  }

  .button-edit {
    background-color: #eee;
    color: #707070;
    font-weight: 400;
    flex: 1;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 0px;
    transition: all 0.2s;
    border-radius: 0 0 4px 0px;

    &:hover {
      background-color: #ddd;
    }
  }

  .button-color {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background-color: #6484ff;
  }

  .add-button-box {
    min-height: 200px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f4f4f4;
    margin: 0px 10px;
    cursor: pointer;
    transition: all 0.2s;
    border-right: 2px solid #eee;
    border-bottom: 2px solid #eee;
    &:hover {
      background-color: #eee;
    }
  }

  .choice-color {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    box-sizing: content-box;
    border: 2px solid #fff !important;
    transition: all 0.2s;
    cursor: pointer;
    &:hover {
      border: 2px solid currentColor !important;
    }

    &-selected {
      border: 2px solid currentColor !important;
    }
  }

  .day-calendar {
    width: 3000px;
    max-width: calc(100vw - 400px);
  }

  .slider {
    width: 100%;
  }

  .number-bubble {
    background-color: #ccc;
    height: 24px;
    width: 24px;
    color: #fff;
    justify-content: center;
    align-items: center;
    font-size: 0.75rem;
    border-radius: 50%;
    display: inline-flex;
  }

  .number-bubble-editable {
    background-color: $primary;
  }

  .number-bubble-selected {
    background-color: $primaryDark !important;
  }

  .input-checkbox {
    height: 26px;
    width: 26px;
  }

</style>
